// Generated file : do not modify
import Route from '@/extend/classes/Route';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import ListData from '@/extend/classes/ListData';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Short URL
export default class ShortUrl  {
  // Identifiant unique
  public id: number;
  // Identifiant
  public ident: string;
  // Module
  public module: string;
  // Fiche
  public fiche: string;
  // Id fiche
  public ficheObjId: number;
  // Section
  public section: string;
  // Id section
  public sectionObjId: number;
  // Dialogue
  public isDialog: boolean;
  // Token
  public token: string;
  // route
  public route: Route;
  // route
  public error: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.ident = '';
    this.module = '';
    this.fiche = '';
    this.ficheObjId = 0;
    this.section = '';
    this.sectionObjId = 0;
    this.isDialog = false;
    this.token = '';
    this.route = new Route();
    this.error = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: ShortUrl): ShortUrl {
    const newShortUrl: ShortUrl = new ShortUrl();
    newShortUrl.id = obj.id;
    newShortUrl.ident = obj.ident;
    newShortUrl.module = obj.module;
    newShortUrl.fiche = obj.fiche;
    newShortUrl.ficheObjId = obj.ficheObjId;
    newShortUrl.section = obj.section;
    newShortUrl.sectionObjId = obj.sectionObjId;
    newShortUrl.isDialog = obj.isDialog;
    newShortUrl.token = obj.token;
    newShortUrl.route = JSON.parse(JSON.stringify(obj.route));
    newShortUrl.error = obj.error;
    newShortUrl.canUpdate = obj.canUpdate;
    newShortUrl.canDelete = obj.canDelete;
    newShortUrl.display = obj.display;
    newShortUrl.notifDefType = obj.notifDefType;
    return newShortUrl;
  }

  public toJsonShortUrl (): string {
    const json = {
      ident: this.ident,
      module: this.module,
      fiche: this.fiche,
      ficheObjId: this.ficheObjId,
      section: this.section,
      sectionObjId: this.sectionObjId,
      isDialog: this.isDialog,
      token: this.token,
      route: this.route,
      error: this.error,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromShortUrl (obj: ShortUrl): void {
    this.id = obj.id;
    this.ident = obj.ident;
    this.module = obj.module;
    this.fiche = obj.fiche;
    this.ficheObjId = obj.ficheObjId;
    this.section = obj.section;
    this.sectionObjId = obj.sectionObjId;
    this.isDialog = obj.isDialog;
    this.token = obj.token;
    this.route = obj.route;
    this.error = obj.error;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareShortUrl (value: ShortUrl): boolean {
    return (this.toJsonShortUrl() == value.toJsonShortUrl());
  }

  public cloneShortUrl (): ShortUrl {
    return ShortUrl.fromJson(this);
  }

  public create (): Promise<ShortUrl> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/shorturls/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromShortUrl(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public update (): Promise<ShortUrl> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/shorturls/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromShortUrl(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public delete (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/shorturls/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static shortUrlRoute (value: string): Promise<ShortUrl> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/shorturls/shortUrlRoute/' + value, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(ShortUrl.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(shortUrls: ShortUrl[]) {
  }
}
